import { render, staticRenderFns } from "./CmgHome.vue?vue&type=template&id=62f40e9b&scoped=true&lang=pug"
import script from "./cmg-home.ts?vue&type=script&lang=ts&external"
export * from "./cmg-home.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgHome.vue?vue&type=style&index=0&id=62f40e9b&prod&lang=scss&scoped=true"
import style1 from "./CmgHome.vue?vue&type=style&index=1&id=62f40e9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f40e9b",
  null
  
)

export default component.exports